
import NetworkLogic from "../../Shared/NetworkLogic";
import AudioManager from "../../Shared/AudioManager";
import PopWindowManager from "../../Shared/PopWindowManager";
import HallUI from "../HallUI";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WechatNotice extends cc.Component {
    @property(cc.Label)
    labMoney:cc.Label = null;
    @property(cc.Label)
    labMoney1:cc.Label = null;

    // onLoad () {}
    //activityMoney: 25
    // bOpen: true
    start () {
        NetworkLogic.wechatNotice({},function (rec) {
            cc.log("===wechatNotice rec:",rec);
            if (rec.bOpen) {
                this.labMoney.string = rec.activityMoney;
                this.labMoney1.string = rec.activityMoney;
            }
        }.bind(this),function () {

        })

    }


    onBtnClose(play = true){
        play && AudioManager.playSound("close");
        PopWindowManager.openNext();
        this.node.destroy();
        //this.node.getComponent(cc.Animation).play();
    }

    onBtnYes(event,param){
        AudioManager.playSound("button");
        let hallUI : HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
        hallUI.onBtnClick(null,"tuiguang");
        this.node.destroy();
    }



}
